__turbopack_context__.v({
  "contactCard": "WarehouseModalContent-module-scss-module__s73ZpW__contactCard",
  "contactGrid": "WarehouseModalContent-module-scss-module__s73ZpW__contactGrid",
  "contactLabel": "WarehouseModalContent-module-scss-module__s73ZpW__contactLabel",
  "contactLink": "WarehouseModalContent-module-scss-module__s73ZpW__contactLink",
  "contactValue": "WarehouseModalContent-module-scss-module__s73ZpW__contactValue",
  "content": "WarehouseModalContent-module-scss-module__s73ZpW__content",
  "description": "WarehouseModalContent-module-scss-module__s73ZpW__description",
  "featureBlock": "WarehouseModalContent-module-scss-module__s73ZpW__featureBlock",
  "featureItem": "WarehouseModalContent-module-scss-module__s73ZpW__featureItem",
  "featureList": "WarehouseModalContent-module-scss-module__s73ZpW__featureList",
  "featureTitle": "WarehouseModalContent-module-scss-module__s73ZpW__featureTitle",
  "iconWrapper": "WarehouseModalContent-module-scss-module__s73ZpW__iconWrapper",
  "infoGrid": "WarehouseModalContent-module-scss-module__s73ZpW__infoGrid",
  "infoList": "WarehouseModalContent-module-scss-module__s73ZpW__infoList",
  "infoRow": "WarehouseModalContent-module-scss-module__s73ZpW__infoRow",
  "label": "WarehouseModalContent-module-scss-module__s73ZpW__label",
  "linkToOffice": "WarehouseModalContent-module-scss-module__s73ZpW__linkToOffice",
  "officeCard": "WarehouseModalContent-module-scss-module__s73ZpW__officeCard",
  "officeValue": "WarehouseModalContent-module-scss-module__s73ZpW__officeValue",
  "row": "WarehouseModalContent-module-scss-module__s73ZpW__row",
  "sectionTitle": "WarehouseModalContent-module-scss-module__s73ZpW__sectionTitle",
  "temperatureItem": "WarehouseModalContent-module-scss-module__s73ZpW__temperatureItem",
  "temperatureList": "WarehouseModalContent-module-scss-module__s73ZpW__temperatureList",
  "tooltip": "WarehouseModalContent-module-scss-module__s73ZpW__tooltip",
  "tooltipAddress": "WarehouseModalContent-module-scss-module__s73ZpW__tooltipAddress",
  "tooltipMore": "WarehouseModalContent-module-scss-module__s73ZpW__tooltipMore",
  "tooltipTitle": "WarehouseModalContent-module-scss-module__s73ZpW__tooltipTitle",
  "value": "WarehouseModalContent-module-scss-module__s73ZpW__value",
});
